import React from 'react';
import { Drawer } from 'antd';

import './sideDrawer.css';

const SideDrawer = ({
  header,
  placement,
  width,
  close,
  visible,
  children,
  classes,
  drawerStyle,
  bodyStyle,
  style,
  closable,
}) => {
  return (
    <Drawer
      destroyOnClose
      title={header}
      placement={placement}
      width={width}
      onClose={close}
      visible={visible}
      className={`sideDrawer ${classes}`}
      drawerStyle={drawerStyle}
      bodyStyle={bodyStyle}
      style={style}
      closable={Boolean(closable)}
    >
      {children}
    </Drawer>
  );
};

export default SideDrawer;
